import { Button, Stack, Tooltip } from "@mui/material";
import { ActionButtons } from "shared/molecules/action-buttons";
import { MultiAcitonButtons } from "shared/molecules/multi-action-buttons";
import TableCell from "@mui/material/TableCell";
import Eclipse from "shared/molecules/eclipse";
import { StatusChip } from "shared/molecules/status-chip";
import { DOMAIN } from "utils/helpers";
import { getTime } from "utils/time-util/getTime";
import { useStyles } from "./styles";
import { RecordingAction, ScheduleActionButtons, ScheduleCopyAction, SessionInstancesAction } from "pages/live-classes/routes/nl3-package-schedules/schedule-buttons/action-buttons";
import { MasterActionButtons } from "pages/live-classes/routes/nl3-liveclass-masters/action-buttons/action-buttons";

function TableData(props: any) {
  const {
    data,
    handleEdit,
    handleDelete,
    handleCopy,
    row,
    id,
    name,
    handleStore,
    handleDeliver,
    handleAnswer,
    handlePreview,
    handleCompare,
    handleAttachSbd,
    handleTestTrigger,
    addUrlNavigation,
    viewPdf,
    viewSolutionPdf,
    viewVideoPdf,
    viewPdfUrl,
    viewSolutionPdfUrl,
    viewVideoPdfUrl,
    previewData,
    handlePdf,
    showPdf,
    viewAudioFile,
    viewAudioFileUrl,
    handleContent,
  } = props;

  const styles = useStyles();

  const handlePdfViewer = (data, item) => {

    let pdfName =
      data.exam_name ||
      data.batch_name ||
      data.assignment_name ||
      data.subject_name;

    const url = item.value === "pdf_name"
      ? data.pdf_url || data.url
      : data[item.value];

    if (!url) return;

  if (data.type === "speak_sphere" || data.type === "n_teractive_worksheet") {
    window.open(url, "_blank", 'noopener,noreferrer');
    return;
  }
  let identifier = ""; 
  let path = "";     

  if (url.includes("nspira.in")) {
    const arr = url.split("://")[1].split("/");
    identifier = arr[0];              
    path = arr.slice(1).join("/"); 
  }

  else if (url.includes("amazonaws.com")) {
    const arr = url.split("/");
    identifier = arr[2].split(".")[0]; 
    path = url.split(".amazonaws.com/")[1];
  }

  else {
    alert("Invalid PDF URL format");
    return;
  }

  window.open(
    `${DOMAIN}/pdf-viewer/${identifier}\`~\`${path}\`~\`${pdfName}\`~\`${data.delivery_count || data.week_number || data.question_count || 0}`,
    "_blank"
  );
  };
  return (
    <>
      {data &&
        data.map((item: any, idx) => {
          if (item.title === "Actions") {
            return (
              <TableCell key={idx} width={item.width}>
                <ActionButtons
                  handleEdit={() => handleEdit(row)}
                  hideEdit={typeof handleEdit !== "function"}
                  handleContent={() => handleContent(row)}
                  hideContent={typeof handleContent !== "function"}
                  handleDelete={() => handleDelete(row[id])}
                  hideDeleteIcon={typeof handleDelete !== "function"}
                  handleCopy={() => handleCopy(row[id])}
                  hideCopyIcon={typeof handleCopy !== "function"}
                  handlePreview={() => handlePreview(row[id])}
                  viewPdfUrl={() => viewPdfUrl(row)}
                  viewSolutionPdfUrl={() => viewSolutionPdfUrl(row)}
                  viewVideoPdfUrl={() => viewVideoPdfUrl(row)}
                  viewPdf={viewPdf}
                  viewSolutionPdf={viewSolutionPdf}
                  viewVideoPdf={viewVideoPdf}
                  previewData={previewData}
                  handlePdf={() => handlePdf(row)}
                  showPdf={showPdf}
                  viewAudioFile={viewAudioFile}
                  viewAudioFileUrl={() => viewAudioFileUrl(row)}
                />
              </TableCell>
            );
          } else if (item.title === "MutliActions") {
            return (
              <TableCell key={idx} width={item.width}>
                <MultiAcitonButtons
                  test={item}
                  handleDeliver={() => handleDeliver(row[id], row[name])}
                  handleAnswer={() => handleAnswer(row[id])}
                  handleEdit={() => handleEdit(row[id], row["test_created_source"])}
                  handlePreview={() => handlePreview(row[id])}
                  handleCompare={() => handleCompare(row[id])}
                  handleAttachSbd={()=> handleAttachSbd(row[id])}
                  handleTestTrigger={()=>handleTestTrigger(row)}
                  handleStore={() => handleStore(row)}
                  addUrlNavigation={() => addUrlNavigation(row)}
                />
              </TableCell>
            );
          } else if (item.value === "ScheduleActions") {
            return (
              <TableCell key={idx} width={item.width}>
                <ScheduleActionButtons
                  handleSessionAllocations={() =>
                    props.handleSessionAllocations(row)
                  }
                  handleLiveSessions={() =>
                    props.handleLiveSessions && props.handleLiveSessions(row)
                  }
                  handleSessionUsages={() =>
                    props.handleSessionUsages && props.handleSessionUsages(row)
                  }
                  handleAllocatedSessions={() =>
                    props.handleAllocatedSessions && props.handleAllocatedSessions(row)
                  }
                  handleCoHost={() =>
                    props.handleCoHost && props.handleCoHost(row)
                  }
                  handleObserver={() =>
                    props.handleObserver && props.handleObserver(row)
                  }
                  handleAttendanceSummary={() =>
                    props.handleAttendanceSummary && props.handleAttendanceSummary(row)
                  }
                  handleEdit={() =>
                    handleEdit && handleEdit(row)
                  }
                  handleDelete={()=>
                    handleDelete && handleDelete(row)
                  }
                  row={row}
                />
              </TableCell>
            );
          } else if (item.value === "scheduleCopyAction") {
            return (
              <TableCell key={idx} width={item.width}>
                <ScheduleCopyAction
                  handleScheduleCopy={() =>
                    props.handleScheduleCopy && props.handleScheduleCopy(row)
                  } />
              </TableCell>
            )
          } else if (item.value === "statusActions") {
            return (
              <TableCell key={idx} width={item.width}>
                <MasterActionButtons
                  handleEnable={() => props.handleEnable && props.handleEnable(row)}
                  handleDisable={() => props.handleDisable && props.handleDisable(row)}
                  row={row}
                />
              </TableCell>
            );
          } else if (item.value === "sessionInstancesAction") {
            return (
              <TableCell key={idx} width={item.width}>
                <SessionInstancesAction
                  handleSessionInstances={() =>
                    props.handleSessionInstances && props.handleSessionInstances(row)
                  }
                  row={row}
                />
              </TableCell>
            );
          } else if (item.value === "recordingAction") {
            return (
              <TableCell key={idx} width={item.width}>
                <RecordingAction
                  handleRecording={() =>
                    props.handleRecording && props.handleRecording(row)
                  }
                  row={row}
                />
              </TableCell>
            );
          } else if (item.renderAs === "status-chip") {
            return (
              <TableCell key={idx} width={item.width}>
                <StatusChip
                  value={row[item.value]}
                  preset={item.statusPreset}
                  map={item.statusMap}
                  activeLabel={item.activeLabel}
                  inactiveLabel={item.inactiveLabel}
                />
              </TableCell>
            );
          }
          else if (
            (item.title.includes("Date") || item.value.includes("date")) &&
            !item.name
          ) {
            return (
              <TableCell>
                {item?.visibleStatus
                  ? row[item.visibleStatus]
                    ? getTime.date(row[item.value], "dd-mm-yy")
                    : "-"
                  : getTime.date(row[item.value], "dd-mm-yy")}
              </TableCell>
            );
          } else if (item.name) {
            return <TableCell>{row[item.value] || "-"}</TableCell>;
          } else if (item.value && item.icon && item.inValue) {
            return (
              <TableCell key={row[item.value][item.inValue] + idx}>
                <Tooltip
                  title={item.tooltip ? row[item.value][item.tooltip] : ""}
                >
                  {row[item.value][item.inValue] ? (
                    <a
                      target="_blank"
                      href={row[item.value][item.inValue]}
                      rel="noreferrer"
                      style={{ color: "blue" }}
                    >
                      {item.icon}
                    </a>
                  ) : (
                    <span>-</span>
                  )}
                </Tooltip>
              </TableCell>
            );
          } else if (
            item.value &&
            item.icon &&
            !item.inValue &&
            item.fileType === "video"
          ) {
            return (
              <TableCell key={row[item.value] + idx}>
                <Tooltip title={item.tooltip ? row[item.tooltip] : ""}>
                  {row[item.value] ? (
                    <a
                      target="_blank"
                      href={row[item.value]}
                      rel="noreferrer"
                      style={{ color: "blue" }}
                    >
                      {item.icon}
                    </a>
                  ) : (
                    <span>-</span>
                  )}
                </Tooltip>
              </TableCell>
            );
          } else if (
            item.value &&
            item.icon &&
            !item.inValue &&
            item.fileType !== "video"
          ) {
            return (
              <TableCell key={row[item.value] + idx}>
                <Tooltip title={item.tooltip ? row[item.tooltip] : ""}>
                  {row[item.value] ? (
                    <div
                      onClick={() => handlePdfViewer(row, item)}
                      style={{ color: "black", cursor: "pointer" }}
                    >
                      {item.icon}
                    </div>
                  ) : (
                    <span>-</span>
                  )}
                </Tooltip>
              </TableCell>
            );
          } else if (item.value && !item.icon && item.inValue) {
            return (
              <TableCell key={row[item.value][item.inValue] + idx}>
                <Eclipse
                  item={
                    row[item.value][item.inValue]
                      ? row[item.value][item.inValue].toString()
                      : "-"
                  }
                />
              </TableCell>
            );
          } else if (item.value != "" && !item.icon && !item.inValue) {
            return (
              <TableCell key={`${Math.random()}-${idx}`} width={item.width}>
                {typeof row[item.value] === "boolean" ? (
                  row[item.value].toString()
                ) : typeof row[item.value] === "number" ? (
                  row[item.value] || "-"
                ) : (
                  <Eclipse
                    item={
                      // row[item.visibleStatus]?row[item.value]:
                      Array.isArray(row[item.value])
                        ? row[item.value] && row[item.value].length > 0
                          ? String(row[item.value] || "-")
                          : "-"
                        : row[item.value]
                          ? row[item.value].toString() ||
                          String(row[item.value] || "-")
                          : String(row[item.value]) || "-"
                    }
                    isConfigueType={item?.type == "configue" ? true : false}
                  />
                )}
              </TableCell>
            );
          } else {
            <TableCell>No Data</TableCell>;
          }
        })}
    </>
  );
}

export default TableData;
